import React, { useEffect, useState } from "react";
//import "./productstable.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPencil,
    faTrash,
    faEye,
} from "@fortawesome/free-solid-svg-icons";

import 'react-toastify/dist/ReactToastify.css';
import Button from "@mui/material/Button";
//import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { useNavigate } from 'react-router-dom';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';

import { Autocomplete, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, MenuItem, TextField, ThemeProvider, createTheme } from "@mui/material";
import { DataGrid, GridApi, GridColDef, GridValueGetterParams, GridCellParams } from '@mui/x-data-grid';

import { CustomerService } from "../../../service/customers.service";
import { isRejected } from "@reduxjs/toolkit";
import { error, timeStamp } from "console";
import { BrandsService } from "../../../service/brands.service";
import { Enterprise } from "../../../model/enterprise.model";
import { EnterpriseService } from "../../../service/enterprise.service";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';


function SalesFeedBackList() {

    const enterpriseSvc = new EnterpriseService();

    const customerService = new CustomerService();
  
    const brandsService = new BrandsService();

    const [feedbackData, setFeedbackData] = useState<any[]>([]);

    //const [availableStatus, setAvailableStatus] = useState<OrderStatus[]>([]);

    //const [selectedEnterprise, setSelectedEntprise] = useState(-1);
    const [startdate, setstartdate] = useState(null);

    const [enddate, setenddate] = useState(null);

    const [fromdate, setfromdate] = useState("");

    const [todate, settodate] = useState("");
    

    
    const [selectedEntOption, setselectedEntOption] = React.useState("select");
    const [availableEnterprise, setAvailableEnterprise] = useState<Enterprise[]>([]);

    const [inputValue, setInputValue] = useState<any>("");

    const [selectedSaleRep, setselectedSaleRep] = useState<any>();
    const [salesRepList, setsalesRepList] = useState<any[]>([]);

    const navigate = useNavigate();

    const toBrandDetails = (bIndex: string, action: string) => {


        navigate('../salesRepFeedbackDetails', {
            state: {
                feedbackDetails: feedbackData[Number(bIndex) - 1],
               // brandsData: feedbackData,
               // action: action
            }
        })
    };

    const [open, setOpen] = React.useState(false);



    const columns: GridColDef[] = [
        { field: 'id', headerName: 'S.no', flex: 1, width: 300 },


        { field: 'salesRepName', headerName: 'Sales Rep', flex: 1  },
        { field: 'entName', headerName: 'Enterprise', flex: 1 },
        { field: 'createdDate', headerName: 'Date', flex: 1 },
     
        {

            field: "action",
            headerName: "Action",
            sortable: false,
            renderCell: (params) => {
                const onClick = (e: { stopPropagation: () => void; }) => {
                    e.stopPropagation(); // don't select this row after clicking

                    const api: GridApi = params.api;
                    const thisRow: Record<string, GridCellParams> = {};

                    api
                        .getAllColumns()
                        .filter((c: { field: string; }) => c.field !== "__check__" && !!c)
                        .forEach(
                            (c: { field: string | number; }) => (thisRow[c.field] = params.value.getValue(params.id, c.field))
                        );
                };

                return <div>
                    <Button onClick={(e) => toBrandDetails(params.value, "edit")} > <IconButton> <EditTwoToneIcon fontSize="small" /></IconButton></Button>

                </div>
            },
            flex: 1
        }

    ];
  

    
  const loadAllEnterprises = () => {
    enterpriseSvc.getActiveEnterprisesList().then(data => {
      const res = data.data;     

      const allent ={entId: -1, entName: "All"};
      const newRes:any[] = [];
      newRes.push(allent);
      newRes.push(...data.data);
     
      
      setAvailableEnterprise(newRes);
     // setselectedEntOption(newRes[1])      

    });
  }
    
  const loadEnterprises = () => {
   // alert(selectedSaleRep)
    customerService.getSalesRepEntDetails(selectedSaleRep).then(res => {

        if (res && res.data && res.data.length>0) {            

            var temparr = []
              
            for (let i = 0 ;i<res.data.length;i++) {
            //   console.log("respp :: idd : ", res.data[i].salesPersonId)
                if (res.data[i].salesPersonId == selectedSaleRep) {
                    temparr = res.data[i].entDetails
                } 
            }

            if (temparr && temparr.length>0) {                    

                    const allent ={entId: -1, entName: "All"};
                    const newRes:any[] = [];
                    newRes.push(allent);
                    newRes.push(...temparr);               
               
                  //  setselectedEntOption({entId: -1, entName: "All"})
                    setAvailableEnterprise(newRes);
                    //setSelectedEntprise(-1) //  (event.target.value)
                    
            }

        }
    
     // setselectedEntOption(newRes[1])      

    });
  }

      
  const loadAllSalesRep = () => {
    customerService.getSalesRepUsers().then(data => {
     // const res = data.data;     
  
      const allent ={ "userid": -1,     
      "username": "All"};
      const newRes:any[] = [];
    
      newRes.push(allent);
      newRes.push(...data.data);
     
      
      setsalesRepList(newRes);
     // setselectedEntOption(newRes[1])      

    });
  }

  
  const CustomFontTheme = createTheme({
    typography: {
      fontSize: 14
    }
  });
  

    const loadSalesRepFeedbacklist = () => {

        //alert("from"+ fromdate + "to"+ todate )

        var entid = Number(selectedEntOption) >0 ? selectedEntOption : ""
        customerService. getSalesRepFeedbackList(selectedSaleRep,entid,fromdate,todate).then(data => {

            try {
                // alert( JSON.stringify(data))
                 console.log("feedback: "+ data.data )
                if (data && data.data) {
                    
                    console.log(JSON.stringify(data.data.length))
                    if ( data.data.length == 0){
                        setFeedbackData([])
                        return
                    }

                    const res = data.data;
                    let cnt1 = 0;

               
                    const createdMap = new Map();
                    salesRepList.map((obj) => {
                        createdMap.set(obj.userid+"", obj.username);
                    });

                   // alert( JSON.stringify(createdMap))

                    const createdEntMap = new Map();
                    availableEnterprise.map((obj) => {
                        createdEntMap.set(obj.entId+"", obj.entName);
                    });

                    //alert( JSON.stringify(createdEntMap))
                    
                    const peopleWithImages = res.map((person: any, index: any) => {
                        cnt1 = cnt1 + 1;
                        return {
                            ...person,
                            id: cnt1,
                            salesRepName: createdMap.get(person.salesRepId+""),
                            entName : createdEntMap.get(person.entId+""),
                            action: cnt1 //person.brandId,
                        };
        
                    });
                    
                    setFeedbackData(peopleWithImages)
                }
             
    
            } catch (error) {
                console.log(error)
            }
           

        },isRejected=>{

        }).catch(error=>{

        });

    }

    let isLoadDataInit = false;
    useEffect(() => {

        if (!isLoadDataInit) {
            isLoadDataInit = true;
            //loadSalesRepFeedbacklist();
            //loadbrandsData()
            loadAllSalesRep()
            //loadAllEnterprises()
        }

    }, [])


    useEffect(() => { 
        
        if (selectedSaleRep &&  selectedSaleRep !=null) {
            //alert(JSON.stringify(availableEnterprise))            
          
           // setAvailableEnterprise([]);
           setselectedEntOption("select")
         

            if (selectedSaleRep <=0) {             

                loadAllEnterprises()
            } else {
                loadEnterprises()
            }        
     
           
        }

    }, [selectedSaleRep])


    useEffect(() => {

        
        if (enddate !=null) {
         
            //loadSalesRepFeedbacklist()
        }

    }, [enddate])
    

     function dateToYMD(timstamp:any) {
        
        var date = new Date(timstamp)
        var d = date.getDate();
        var m = date.getMonth() + 1; //Month from 0 to 11
        var y = date.getFullYear();
        return '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
      }

      const filterOptions = (options:any, state:any) => {
  
        let newOptions : any= [];
        options.forEach((element:any) => {
          //alert(state.inputValue)
          console.log("logg : "+ state)
          if (
            
            element.username
              .toLowerCase()
              .includes(state.inputValue.toLowerCase())
          )
            newOptions.push(element);
        });
        return newOptions;
      };


      const filterOptionsEnt = (options:any, state:any) => {
  
        let newOptions : any= [];
        options.forEach((element:any) => {
          //alert(state.inputValue)
          console.log("logg : "+ state)
          if (
            
            element.entName
              .toLowerCase()
              .includes(state.inputValue.toLowerCase())
          )
            newOptions.push(element);
        });
        return newOptions;
      };


    return (
        <div className="App border card">
            <div className="col-md-12 mt-4 row">

                
            <div className="col-3 form-group  text-left">
            <Autocomplete
                  size="small" 
                  value={selectedSaleRep}
                  //defaultValue={{ "userid": -2, "username": "Select"}}
                  onChange={(event: any, newValue: any) => {
                    //setValue(newValue);
                    setselectedSaleRep(newValue?.userid!!) //  (event.target.value)
                    
                    
                  }}
               
                  id="controllable-states-demo"
                  options={salesRepList}
                  filterOptions={filterOptions}
                  getOptionLabel={(option) => option.username}                  
                  renderInput={(params) => <TextField {...params} label="Sales Representative" />}
                />

</div>

{

selectedSaleRep!=null && (selectedSaleRep>0 )  &&  <div className="col-3 form-group  text-left">
<ThemeProvider theme={CustomFontTheme}>
<TextField select size="small" label="Enterprise Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 40 } }}
  className="form-control" name='brandId' defaultValue="select" value={selectedEntOption}
  
  onChange={(e: any) => {
    setselectedEntOption(e.target.value);
  }}>
  <MenuItem style={{ fontSize: "small" }} disabled value="select" key="select">Select</MenuItem>
  {availableEnterprise.map((_el: any) => <MenuItem style={{ fontSize: "small" }} key={_el.entId} value={_el.entId}>{_el.entName}</MenuItem>)}
</TextField>
</ThemeProvider>

</div>
}

           { /* selectedSaleRep!=null && (selectedSaleRep>0 )  &&  <div className="col-3 form-group  text-left">
            <Autocomplete
                  size="small" 
              //    value={selectedEntOption}
                  value={availableEnterprise.find((option:any) => option.entId === selectedEntOption)}
                //  onChange={(_, v) => setValue(v?.value)}


                  inputValue={inputValue}
                 // defaultValue={{entId: -1, entName: "All"}}
                  onChange={(event: any, newValue: Enterprise | null) => {
                    //setValue(newValue);
                    //setSelectedEntprise(newValue?.entId!!) //  (event.target.value)
                    // alert(JSON.stringify(newValue!!))
                    setselectedEntOption(newValue?.entId!!)
                  }}
               
                  id="controllable-states-demo"
                  options={availableEnterprise}
                  onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                  }}
                  filterOptions={filterOptionsEnt}
                  isOptionEqualToValue={(option, selectedValue) => option.entId === selectedValue.entId}  
                  getOptionLabel={(option) => option.entName}     
                               
                  renderInput={(params) => <TextField {...params} label="Enterprise Name" />}
                />

                </div> */ }
              {/*  <div className="col-6 text-right font_size_12px"></div> */}
           
              <LocalizationProvider dateAdapter={AdapterDayjs}>
      
        
                <DatePicker
                sx={{ width: '12%' }}
                slotProps={{ textField: { size: 'small' } }}
                label="From Date"
                value={startdate}
                onChange={(newValue:any) => 
                    {
                        //alert( JSON.stringify(dateToYMD(newValue)))
                      // setstartdate(newValue)
                    }
                }
                
                onAccept={(param)=> {
                    //alert( JSON.stringify(dateToYMD(param)))
                    setfromdate(dateToYMD(param))
                    setstartdate(param)
                   // alert(JSON.stringify(param))
                }}
                />

                <div style={{width:15}} > </div>

               <DatePicker
                     sx={{ width: '12%' }}
                slotProps={{ textField: { size: 'small' } }}
                label="To Date"
                value={enddate}
                // onChange={(newValue:any) => setenddate(newValue)}
                onAccept={(param:any)=> {
                    //alert( JSON.stringify(dateToYMD(param)))
                    settodate(dateToYMD(param))
                    setenddate(param)
                   // alert(JSON.stringify(param))
                }}
                />
            
    </LocalizationProvider>

  
            <div className="col-1 text-right">
            <Button style={{ color: "green" ,backgroundColor:'#76CD81' , height:40 , }} className="mr-4" onClick={() => {
                    loadSalesRepFeedbacklist()
            }} variant="text"// startIcon={<ArrowUpwardRoundedIcon />}
            >
              Submit
            </Button>

                </div>


            </div>
            {
                <div style={{ width: '100%' }}>
                    <DataGrid
                        // table customization start
                        sx={{
                            '& .MuiDataGrid-columnHeaderTitle': {
                                whiteSpace: "break-spaces", lineHeight: 1, fontSize: "13px", fontWeight: "bold",
                            },
                            '& .MuiDataGrid-columnHeader': {
                                backgroundColor: "#D0D0D0"
                            },
                            '& .Mui-odd': {
                                textOverflow: "inherit", fontSize: "12px", textAlign: "left"
                            },

                            '& .Mui-even': {
                                backgroundColor: "#F7f7f7", textOverflow: "inherit", fontSize: "12px", textAlign: "left"

                            },

                            '& .Mui-cellown': {
                                paddingTop: 0, paddingBottom: 0

                            },

                        }}

                        getCellClassName={(params) => 'Mui-cellown'}
                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
                        autoHeight={true}
                        getRowHeight={() => 'auto'}

                        // table customization


                        rows={feedbackData}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: { page: 0, pageSize: 10 },
                            },
                        }}
                        pageSizeOptions={[10, 25, 50]}

                    />
                </div>
            }
        </div>

    );
}


export default SalesFeedBackList;
